const SEEN_KEY = "alphaapeing_creator_seen";

export const getSeenSet = () => {
  try { return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]")); } catch { return new Set(); }
};

export const markCreatorSeen = (mints) => {
  localStorage.setItem(SEEN_KEY, JSON.stringify([...new Set(mints)]));
  window.dispatchEvent(new Event("creator-seen-updated"));
};

export function mergeSources(radar, launches, buys) {
  const map = new Map();
  const put = (mint, item) => {
    if (!mint) return;
    const cur = map.get(mint) || { mint, sources: new Set(), ts: 0 };
    map.set(mint, {
      ...cur,
      ...Object.fromEntries(Object.entries(item).filter(([, v]) => v != null && v !== "")),
      mint,
      sources: cur.sources,
      ts: Math.max(cur.ts || 0, item.ts || 0),
    });
    map.get(mint).sources.add(item.source);
  };
  radar.forEach((c) => put(c.address, {
    symbol: c.symbol, name: c.name, image: c.image, creator: c.creator, url: c.url,
    score: c.score?.total, verdict: c.score?.verdict, marketCap: c.marketCap,
    ts: c.ageHours ? Math.floor(Date.now() / 1000 - c.ageHours * 3600) : 0, source: "radar",
  }));
  launches.forEach((t) => put(t.mint, {
    symbol: t.symbol, name: t.name, image: t.image, creator: t.creator, url: t.url,
    curveProgress: t.curveProgress, buys5: t.buys5, ts: t.createdTs, source: "launch",
  }));
  buys.forEach((t) => put(t.tokenMint, {
    symbol: t.tokenSymbol, name: t.tokenName, image: t.tokenImage, creator: t.creator,
    walletCount: t.walletCount, ts: t.lastTimestamp, source: "buy",
  }));
  return [...map.values()];
}
